<template>
  <el-dialog title="选择技术老师主图" :visible.sync="openImage" width="950px" append-to-body :close-on-click-modal="false" v-if="openImage">
    <el-form :model="query" ref="query" :inline="true" label-width="68px">
      <el-form-item label="老师信息">
        <el-input v-model="query.keyWords" placeholder="请输入姓名/手机号查询" clearable size="small" @keyup.enter.native="handleQuery" />
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search" size="mini" @click="handleQuery">搜索</el-button>
        <el-button type="success" size="mini" @click="handleSure">确认</el-button>
      </el-form-item>
    </el-form>
    <div class="pic-cont">
      <div v-for="(item,index) in list" :key="index" class="img-list">
        <el-checkbox v-model="item.checked" @change="handleClickImg(item)"></el-checkbox>
        <img :src="item.promotionImg" alt="" @click="handleClickImg(item)">
        <p><a :title="item.name">{{item.name}}({{ item.identity }})<br/>{{ item.phone }}</a></p>
      </div>

    </div>
    <pagination v-show="total>0" :total="total" :pageNo.sync="query.pageNo" :pageSize.sync="query.pageSize" @pagination="doQueryList" />
  </el-dialog>
</template>
<script>
import templateTeacherApi from '@/api/marketing/templateTeacher'
import Pagination from '@/components/Pagination'
export default {
  components: {
    Pagination
  },
  data() {
    return {
      listLoading: true,
      list: [],
      total: 0,
      query: {
        pageNo: 1,
        pageSize: 10,
        state: 1, // 默认启用状态
        keyWords: undefined,
      },
      openImage: false
    };
  },
  created() {

  },
  methods: {
    doQueryList(params = {}) {
      const { pageNo, pageSize } = params
      if (pageNo) {
        this.query.pageNo = pageNo
      }
      if (pageSize) {
        this.query.pageSize = pageSize
      }
      this.listLoading = true
      return templateTeacherApi.fetchList(this.query)
        .then(data => {
          this.list = data.data.list
          this.total = data.data.total
        })
        .finally(() => {
          this.listLoading = false
        })
    },
    handleCreate() {
      this.doQueryList({ pageNo: 1 });
      this.openImage = true
    },
    handleClickImg(item) {
      this.list.forEach(itt => {
        itt.checked = itt.id === item.id ? true : false
      })
      this.$forceUpdate();
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.query.pageNo = 1
      this.doQueryList({});
    },
    handleSure() {
      let find = this.list.find(itt => itt.checked)
      if (!find) return this.$message.error("请选择图片");
      this.openImage = false
      this.$emit("created", find)
    },
  },
  watch: {},
};
</script>
<style scoped lang="scss">
::v-deep .el-dialog {
  height: 670px;
}
.pic-cont {
  width: 100%;
  height: calc(100% - 59px);
  border-top: 1px solid #f7f7f7;
  position: relative;
  display: inline-block;
  overflow-y: scroll;
  padding-left: 20px;
  box-sizing: border-box;

  .txt-hint {
    text-align: center;
    padding-top: 20px;
    p {
      margin: 0;
      &:nth-child(1) {
        font-weight: 600;
      }
    }
  }
  .img-list {
    display: inline-block;
    padding: 10px;
    text-align: center;
    position: relative;
    overflow: hidden;
    .el-checkbox {
      position: absolute;
      left: 10px;
      top: 10px;
    }
    &:nth-child(5n) {
      margin-right: 0;
    }
    p {
      margin: 0;
      overflow: hidden;
      white-space: nowrap;
      text-overflow: ellipsis;
      width: 150px;
      a {
        cursor: pointer;
      }
    }
    img {
      width: 150px;
      height: 150px;
      border: 1px solid #ccc;
      cursor: pointer;
      background-color: #e5f3ff;
    }
  }
}

::v-deep .el-dialog__body {
  .el-form {
    padding-left: 30px;
  }
}
::v-deep .el-checkbox__inner {
  border-radius: 50%;
}
</style>

